import moment from 'moment'
import { RequestOVsByFilters } from 'services/manage_ov/interface'
import _ from 'lodash'
import { caracteristicasOptions, Icon, StatusType, Tooltip } from 'components'
import { store } from 'store/store'

import { DraftProps, Ordemvenda } from 'container/Home/components/Banners/interface'
import { CustomBoolean, TypesValidations } from 'constants/enums'
import { ClientsListInterface } from 'container/SalesOrder/components/ModalPostOn'
import { SalesOrderData } from 'store/SalesOrderContext/types/SalesOrderData'
import { getUser } from 'commons/utils/user'
import { ViewByType } from '..'
import { OriginOrder, StatusEDI, StatusNdType } from 'constants/enums'

import { theme } from 'styles/theme/hav-theme'

export const convertArray = (value?: string) => {
  if (typeof value === 'string' && value !== '') {
    return value?.trim().split(',')
  }
  return []
}

export const convertArrayNumber = (value: string[]) => {
  if (value) {
    return value.map((item: string) => {
      return parseInt(item)
    })
  }
  return []
}

// TODO: Refactor this to use ENUMs
export const getOrderStatusCodes = (values?: string[]) => {
  if (values?.length) {
    return values.map((status) => {
      if (status === 'Em aberto') return 0
      if (status === 'Em análise') return 10
      if (status === 'Aprovado') return 20
      if (status === 'Restrito') return 90
      if (status === 'Concluído') return 100
    })
  }
  return []
}

export const formatMaterialMTO = (value?: string) => {
  if (value === '2') return false
  if (value === '1') return true

  return null
}
export interface FormatBodyType {
  codigosCores?: string | string[]
  codigoSapCliente?: string
  codigoTipoOrdem?: string
  codigoZona?: string | string[]
  codigosCentros?: string[]
  codigosMateriais?: string | string[]
  codigosStatusEstoque?: string[]
  codigosStatusOrdemVenda?: string[] | number[]
  codigosStatusPedido?: string | string[]
  dataFinal?: string
  dataInicial?: string
  documentoFatura?: string
  escritorioVenda?: string | string[]
  equipeVenda?: string | string[]
  mercado?: string | string[]
  hierarquia?: boolean | string
  materialMTO?: number | string
  caracteristicas?: string[]
  numeroNotaFiscal?: string
  numeroOrdemVenda?: string
  numeroOrdemVendaSAP?: string
  numeroPedidoCliente?: string
  numeroPedidoRascunho?: string
  page?: number
  searchBox?: string
  periodo?: string
  flagPedidoAntecipado?: CustomBoolean
  flagExibeEdi?: string
  flagExibeNd?: string
  flagExibeVolumeExtra?: string
  flagExibeHC?: string
  numeroPedidoEDI?: string
}

export const formatRequestBodyByFilters = (
  body: FormatBodyType,
  skipDates?: boolean,
  viewBy?: ViewByType,
  isReport?: boolean
): RequestOVsByFilters => {
  const dates = body.periodo ? body.periodo.split(' - ') : []

  // TODO: Refactor this to use utils/date
  const initialDate =
    dates.length && !skipDates
      ? moment(dates[0], 'DD/MM/YYYY').startOf('day').toISOString()
      : null
  // TODO: Refactor this to use utils/date
  const endDate =
    dates.length && !skipDates && dates[1] !== moment().format('L')
      ? moment(dates[1], 'DD/MM/YYYY').endOf('day').toISOString()
      : null

  const { comercialStructure: offices } = store.getState().management
  const selectedOffices =
    typeof body.escritorioVenda === 'string'
      ? convertArray(body.escritorioVenda)
      : body.escritorioVenda
  const allOfficesSelected = selectedOffices?.length === offices.length

  const allTeams = offices.flatMap((office) => office.Equipes.map((team) => team.Codigo))
  const selectedTeams =
    typeof body.equipeVenda === 'string'
      ? convertArray(body.equipeVenda)
      : body.equipeVenda
  const allTeamsSelected = selectedTeams?.length === allTeams.length

  const allZones = offices.flatMap((office) =>
    office.Equipes.flatMap((team) => team.Regioes.flatMap((zone) => zone.Codigo))
  )
  const selectedZones =
    typeof body.codigoZona === 'string' ? convertArray(body.codigoZona) : body.codigoZona
  const allZonesSelected = selectedZones?.length === allZones.length

  const optionsStatusCodes = [0, 10, 20, 90, 100]
  const selectedStatusCodes =
    typeof body.codigosStatusPedido === 'string'
      ? getOrderStatusCodes(body.codigosStatusPedido.split(','))
      : getOrderStatusCodes(body.codigosStatusPedido)
  const allStatusSelected = selectedStatusCodes?.length === optionsStatusCodes.length

  const caracteristicas =
    typeof body.caracteristicas === 'string'
      ? (body?.caracteristicas as string)?.split(',')
      : body.caracteristicas || []

  const exibeHC = caracteristicas?.find(
    (item) => item === caracteristicasOptions[0].title // NOTE: 'Gerado no Hava Conecta'
  )
    ? TypesValidations.YES
    : null
  const exibeEdi = caracteristicas?.find(
    (item) => item === caracteristicasOptions[1].title // NOTE: 'Gerado por EDI'
  )
    ? TypesValidations.YES
    : null
  const exibeNd = caracteristicas?.find(
    (item) => item === caracteristicasOptions[2].title // NOTE: 'Negociação diferenciada (ND)'
  )
    ? TypesValidations.YES
    : null
  const exibeVolumeExtra = caracteristicas?.find(
    (item) => item === caracteristicasOptions[3].title // NOTE: 'Com volume extra'
  )
    ? TypesValidations.YES
    : null

  let formattedBody = {
    ...body,
    codigoSapCliente: convertArray(body.codigoSapCliente),
    codigosStatusOrdemVenda:
      typeof body.codigosStatusOrdemVenda === 'object'
        ? body.codigosStatusOrdemVenda
        : body.codigosStatusOrdemVenda &&
          convertArrayNumber(convertArray(body.codigosStatusOrdemVenda)),
    codigosStatusPedido: !allStatusSelected ? selectedStatusCodes : [],
    equipeVenda: !allTeamsSelected ? selectedTeams : [],
    codigoZona: !allZonesSelected ? selectedZones : [],
    escritorioVenda: !allOfficesSelected ? selectedOffices : [],
    dataFinal: endDate,
    dataInicial: initialDate,
    codigosCentros:
      typeof body?.codigosCentros === 'string'
        ? convertArray(body.codigosCentros)
        : body?.codigosCentros,
    codigosMateriais:
      typeof body?.codigosMateriais === 'string'
        ? convertArray(body.codigosMateriais)
        : body?.codigosMateriais,
    codigosCores:
      typeof body?.codigosCores === 'string'
        ? convertArray(body.codigosCores)
        : body?.codigosCores,
    materialMTO: formatMaterialMTO(String(body.materialMTO)),
    numeroNotaFiscal: convertArrayNumber(convertArray(body.numeroNotaFiscal)),
    numeroOrdemVenda: convertArray(body.numeroOrdemVenda),
    numeroOrdemVendaSAP: convertArray(body.numeroOrdemVendaSAP),
    numeroPedidoCliente: convertArray(body.numeroPedidoCliente),
    numeroPedidoRascunho: convertArray(body.numeroPedidoRascunho),
    searchBox:
      body.searchBox &&
      body.searchBox.replaceAll('.', '').replaceAll('/', '').replaceAll('-', ''),
    hierarquia:
      typeof body.hierarquia === 'string' ? body.hierarquia === 'true' : body.hierarquia,
    flagPedidoAntecipado:
      viewBy === 'orderAnticipation' ? TypesValidations.YES : TypesValidations.NO,
    documentoFatura: body?.documentoFatura ? convertArray(body?.documentoFatura) : [],
    flagExibeHC: exibeHC,
    flagExibeEdi: exibeEdi,
    flagExibeNd: exibeNd,
    flagExibeVolumeExtra: exibeVolumeExtra,
    numeroPedidoEDI: convertArray(body.numeroPedidoEDI)
  }

  delete formattedBody.periodo
  delete formattedBody.caracteristicas

  if (isReport) delete formattedBody.page

  if (viewBy === 'orderAnticipation') {
    formattedBody = {
      ...formattedBody,
      numeroOrdemVenda: [],
      numeroOrdemVendaSAP: [],
      documentoFatura: [],
      numeroNotaFiscal: [],
      codigosCentros: [],
      codigosStatusOrdemVenda: [],
      flagExibeHC: null,
      flagExibeNd: null,
      flagExibeVolumeExtra: null,
      flagExibeEdi: null
    }
  }

  const clearedBody = _.omitBy(formattedBody, (v) => v === undefined)

  return {
    ...clearedBody
  }
}

export type GetNegDif = {
  flag: Ordemvenda['fl_negc_difd']
  isJustified: Ordemvenda['dt_just_negc_difd']
  ovStatus: number
}

const getIsNegDif = (ovs: GetNegDif[]): undefined | StatusNdType => {
  let isNegDif: undefined | StatusNdType

  for (const ov of ovs) {
    if (ov.flag === TypesValidations.YES && !ov.isJustified) return 'pending'
    if (ov.flag === TypesValidations.YES && ov.isJustified) {
      isNegDif = 'justified'
    }
  }
  const ovsNegDif = ovs.filter((ov) => ov.flag === TypesValidations.YES)

  const ovsNegDifApproved = ovs.filter(
    (ov) => ov.flag === TypesValidations.YES && ov.isJustified && ov.ovStatus > 10 && ov
  )

  return isNegDif === 'justified' && ovsNegDifApproved.length === ovsNegDif.length
    ? 'approved'
    : isNegDif
}

export const getNegDifRowIcon = (ovs: GetNegDif[] | undefined): JSX.Element => {
  const statusNd = ovs?.length ? getIsNegDif(ovs) : undefined

  const isNegDif: Record<StatusNdType, { title: string; color: string }> = {
    approved: {
      title: 'Justificativa aprovada',
      color: theme.colors.alert.success.dark
    },
    pending: {
      title: 'Justificativa pendente',
      color: theme.colors.alert.danger.dark
    },
    justified: {
      title: 'Justificado',
      color: theme.colors.neutral.light
    }
  }

  if (statusNd === undefined) return <></>

  return (
    <Tooltip title={isNegDif[statusNd].title}>
      <span>
        <Icon icon="nd" color={isNegDif[statusNd].color} />
      </span>
    </Tooltip>
  )
}

export const getHavaRowIcon = (origin: OriginOrder, isOV = false) => {
  if (origin === OriginOrder.HAVA) {
    const message = isOV
      ? 'Pedido via Hava Conecta gerado com sucesso'
      : 'OV derivada de pedido gerado via Hava Conecta'

    return (
      <Tooltip title={message}>
        <span>
          <Icon icon="hc" />
        </span>
      </Tooltip>
    )
  }

  return <></>
}

export const getEDIRowIcon = (
  origin?: OriginOrder,
  status?: StatusEDI | null,
  isOV = false
) => {
  if (origin === OriginOrder.EDI) {
    const statusEDI: Record<StatusEDI, { title: string; color: string }> = {
      [StatusEDI.Success]: {
        title: 'Pedido via EDI gerado com sucesso',
        color: theme.colors.alert.success.dark
      },
      [StatusEDI.Pending]: {
        title: 'Pedido via EDI com solicitação pendente de alteração',
        color: theme.colors.alert.warning.dark
      },
      [StatusEDI.Error]: {
        title: 'Erro na geração do pedido via EDI',
        color: theme.colors.alert.danger.dark
      }
    }

    // NOTE: For OVs, status is always null
    status = isOV ? null : StatusEDI.Success // TODO: Replace this "StatusEDI.Success" with "status" when EDI status is available by API

    const titleOrder = status
      ? statusEDI[status].title
      : 'OV derivada de pedido gerado via EDI'

    const title = isOV ? 'OV derivada de pedido gerado via EDI' : titleOrder
    const color = status ? statusEDI[status].color : theme.colors.neutral.light

    return (
      <Tooltip title={title}>
        <span>
          <Icon icon="edi" color={color} />
        </span>
      </Tooltip>
    )
  }

  return <></>
}

export const getPostOnBody = (
  array: ClientsListInterface[],
  draftBody: SalesOrderData,
  orderNumber?: string
) => {
  const clientes = array.map((record) => ({
    cd_clie: record.cd_clie,
    fl_mto_prep: draftBody.fl_mto_prep,
    fl_dupl_matr: TypesValidations.YES,
    nr_pedi_clie: record.nr_pedi_clie ?? '',
    fl_dupl_text: record?.text ? TypesValidations.YES : TypesValidations.NO
  }))

  const body = {
    nr_pedi_rasc_orig: orderNumber || '',
    Clientes: clientes,
    cd_usua_alte: getUser()
  }

  return body
}

export function getOrderStatus(draft: DraftProps) {
  if (draft.CodigoStatusPedido === 0) return StatusType.ABERTO
  if (draft.CodigoStatusPedido === 10) return StatusType.ANALISE
  if (draft.CodigoStatusPedido === 90) return StatusType.RESTRITO

  return StatusType.CONCLUIDO
}
